<template>
  <!-- 同比环比 -->
  <div class="curveWrapper main">
    <div class="head" style="margin-bottom:0.24rem">
      <!-- 搜索区域 -->
      <div class="searchArea">
          <div class="title">查询筛选</div>
          <div class="content">
              <el-form style="width: 90%"  label-width="90px">
                  <el-row :gutter="24">
                      <el-col :span="24">
                          <el-form-item label="选择设备：">
                              <el-select v-model="quantitySelected" placeholder="请选择" size="small" @click.native="selectDevice">
                                  <el-option label="" value=""></el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                  </el-row>
                  <el-row :gutter="24">
                      <el-col :span="12">
                           <el-form-item label="选污染物：">
                              <el-select v-model="searchParam.wryName" placeholder="请选择" size="small" @change="searchChange($event,'wry')">
                                  <el-option v-for="(item,index) in DeviceParamsSD"
                                   :label="item.name"
                                   :value="item.name"
                                   :key="index"></el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12">
                          <el-form-item label="选择日期：">
                          <el-date-picker
                            v-model="searchParam.date"
                            type="month"
                            placeholder="选择月"
                            size="small"
                            value-format="yyyy-MM"
                            @change="onChangeDate">
                          </el-date-picker>
                          </el-form-item>
                      </el-col>
                  </el-row>
              </el-form>
              <div class="block"></div>
              <div class="rightBtn">
                  <el-button type="primary" icon="el-icon-search" size="small" class="btnStyle" style="margin-bottom:0.1rem" @click="searchBtnClick">查询</el-button>
                  <el-button icon="el-icon-refresh-left" size="small" style="margin-left: 0;"  @click="resetting">重置</el-button>
              </div>
          </div>
      </div>
    </div>
    <!-- 图表 -->
    <section class="section">
       <div class="sectionSearch">
        <div class="title">
          <div>同比环比<span style="padding: 0 0.1rem;color:#ccc">|</span></div>
          <div>{{quantitySelected}}</div>
          <div v-if="isExpand" class="el-icon-caret-right" style="font-size:0.24rem" @click="isExpand = false"></div>
          <div v-if="!isExpand" class="el-icon-caret-bottom" style="font-size:0.24rem"  @click="isExpand = true"></div>
        </div>
      </div>
      <div class="expandContent" v-if="!isExpand">
           <div class="item" v-for="(item,index) in selectedRows" :key="index">
              <div class="round"></div>
              <span>{{item.name}}</span>
           </div>
      </div>

      <!-- 折线图 -->
      <CompareBar2 ref="CompareBar2"
                   :ajaxParam="ajaxParam"
                   :scrollTop="scrollTop" />
    </section>
  </div>
</template>

<script>
import Com from '../.././common/js/com.js'
import CompareBar2 from '@/components/dataCompare/children/compareBar2.vue'
import CompareDown2 from '@/components/dataCompare/children/compareDown2.vue'
export default {
  props: ['paramsObject'], /* selectedRows: 表格选中数据 */
  components: {
    CompareBar2,
    CompareDown2
  },
  data () {
    return {
      searchParam: { /* 页面搜索项 */
        wry: '', /* 污染源 */
        wryName: '',
        date: '',
        dateArr: [],
        dateArr2: [],
        code: [],
        category: [],
        Eparam: ''
      },
      ajaxParam: {}, /* 柱状图柱状图入参 */
      selectedRows: [], /* selectedRows: 表格选中数据 */
      scrollTop: 0,
      quantitySelected:'', // 已选设备数量
      isExpand: true,
    }
  },
  created () {
    const menu3Search = window.sessionStorage.getItem('menu3Search')
    if (menu3Search) {
      const menu3SearchObj = JSON.parse(menu3Search)
      //   console.log(menu3SearchObj, '--------------->同比环比缓存')
      this.searchParam.date = menu3SearchObj.date
      this.searchParam.wry = menu3SearchObj.wry
      this.searchParam.wryName = menu3SearchObj.wryName
      this.searchParam.Eparam = menu3SearchObj.Eparam
    } else {
      const date = Com.stringTime((new Date()), 'month')
      this.searchParam.date = date
    }
  },
  mounted () {
    if (this.paramsObject) { // props参数
      this.selectedRows = this.paramsObject
      this.searchBtnClick() // 查询事件
    }
    document.getElementById('bodyWrapperId').addEventListener('scroll', () => {
      const top = document.getElementById('bodyWrapperId').scrollTop
      this.scrollTop = top
    })
  },
  methods: {
    selectDevice() { // 选择设备
      this.$emit('isShow',true)
    },
    searchChange: function (val, type) {
      if (type === 'wry') {
        this.searchParam.wryName = val
        this.searchParam[type] = val
        this.searchParam.Eparam = val
      } else {
        this.searchParam[type] = val
      }
    },
    onChangeDate: function (date) { // 日期选择
      this.date = date
    },
    searchBtnClick: function () { // 查询事件
      this.ajaxParam = {
        wry: this.searchParam.wry, /* 污染源 */
        wryName: this.searchParam.wryName,
        date: this.searchParam.date,
        dateArr: this.searchParam.dateArr,
        dateArr2: this.searchParam.dateArr2,
        code: this.searchParam.code,
        category: this.searchParam.category,
        Eparam: this.searchParam.Eparam
      }
      this.filterFun() // 过滤数据
      window.sessionStorage.setItem('menu3Search', JSON.stringify(this.ajaxParam))
      // console.log(JSON.stringify(this.ajaxParam), '------->柱状图2入参')
      this.$refs.CompareBar2.initChart(this.ajaxParam, this.scrollTop)
    },
    filterFun: function () { // 过滤数据
      // 添加同比环比日期
      const dateArr = [[], [], []]
      const dateArr2 = []
      const today = this.ajaxParam.date
      const arr = today.split('-') // 今天日期
      const todatLast = Com.getPreMonth(today) // 环比日期
      const arr2 = todatLast.split('-')

      var days1 = new Date(arr[0], arr[1], 0).getDate() // 获取当前日期中月的天数
      var days2 = new Date((Number(arr[0]) - 1), arr[1], 0).getDate() // 获取同比日期中月的天数
      var days3 = new Date(arr2[0], arr2[1], 0).getDate() // 获取环比日期中月的天数
      dateArr[0].push([today + '-01', today + '-' + days1])
      dateArr[1].push([(Number(arr[0]) - 1) + '-' + arr[1] + '-01', (Number(arr[0]) - 1) + '-' + arr[1] + '-' + days2])
      dateArr[2].push([todatLast + '-01', todatLast + '-' + days3])
      this.ajaxParam.dateArr = dateArr

      dateArr2[0] = (today)
      dateArr2[1] = ((Number(arr[0]) - 1) + '-' + arr[1])
      dateArr2[2] = (todatLast)
      this.ajaxParam.dateArr2 = dateArr2

      // 过滤数据
      if (this.selectedRows.length > 0) {
        const code = []
        const category = []
        this.selectedRows.forEach((item, i) => {
          code.push(item.code)
          category.push(item.name)
        })
        this.ajaxParam.code = code.join(',')
        this.ajaxParam.category = code
      }
    },
    resetting() {

    },
  },
  watch: {
    paramsObject: {
      handler: function (value) { // props参数
      this.quantitySelected = '已选择'+ value.length + '台设备'
        const result = JSON.parse(JSON.stringify(value))
        this.selectedRows = result
        this.searchBtnClick() // 查询时间
      },
      deep: true
    },
    DeviceParamsSD: {
      handler: function (result) {
        this.searchParam.wryName = result[0].name
        this.searchParam.wry = result[0].name
        this.searchParam.Eparam = result[0].name
      },
      deep: true
    },
  },
  computed: {
    DeviceParamsSD: function () {
      return this.$store.state.moduleSD.DeviceParamsSD
    },
  },
}
</script>

<style lang="less" scoped>
.curveWrapper {
  height: calc(100% - 0.64rem);
  display: flex;
  flex-direction: column;
}
.section {
  padding: 0.24rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  .sectionSearch {
    display: flex;
    .title {
      display: flex;
      align-items: center;
      font-size: 0.16rem;
      color:#405891;
      font-weight: bold;
    }
  }
}
.timeGroup > span {
  font-size: 0.14rem;
  color: rgba(0, 0, 0, 0.65);
  padding: 0 0.1rem;
}
::v-deep .el-form-item {
  margin-bottom: 0.1rem;
  .el-form-item__label {
      color: #405891;
  }
}
::v-deep .el-select {
  width: 100%;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}
.expandContent {
  color: #405891;
  padding: 0 0.24rem 0.24rem 0.24rem;
  margin-bottom: 0.1rem;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #cccc;
  .item {
    margin-right: 0.25rem;
    margin-bottom: 0.1rem;
    .round {
      width: 10px;
      height: 10px;
      border: 2px solid #437EDE;
      border-radius: 50%;
      display: inline-block;
      margin-right: 10px;
    }
  }
}
</style>
